import axios from 'axios';
import { api, initialSentry, identifyTracker, getServiceConfig } from 'utility';
import {
  getBusinessUrl,
  getUserLastLogin,
  getRevoketUrl,
  getRefreshUrl,
  getVerifyUrl,
  getLoginOtpUrl,
  getLoginUrl,
  getLoginOwnerUrl
} from 'URLs';

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z\d+.-]*:)?\/\//i;

function joinUrlParts(baseUrl, path) {
  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

function getFallbackBaseUrl() {
  const apiHost = process.env.REACT_APP_API_JAVA || '';
  const configuredBaseUrl = process.env.REACT_APP_BASE_URL || '/api';

  if (ABSOLUTE_URL_PATTERN.test(configuredBaseUrl)) {
    return configuredBaseUrl;
  }

  return apiHost
    ? joinUrlParts(apiHost, configuredBaseUrl)
    : configuredBaseUrl;
}

async function getAuthBaseUrl({ skipServiceConfig = false } = {}) {
  if (!skipServiceConfig) {
    try {
      const serviceConfigResponse = await getServiceConfig();
      const responseData =
        serviceConfigResponse?.data ?? serviceConfigResponse ?? {};
      const serviceConfig = responseData?.result ?? responseData ?? {};

      if (serviceConfig.baseUrl) {
        return serviceConfig.baseUrl;
      }
    } catch (error) {
      // Login must still be available when service config is unavailable.
    }
  }

  return getFallbackBaseUrl();
}

export default class AuthApi {
  static businessData = null;
  static actionData = null;


  static getLoginBusinessUrl = async (params) => {
    const baseUrl = await getAuthBaseUrl();
    const urlServer = joinUrlParts(baseUrl, getLoginOwnerUrl());

    return axios.get(urlServer, { params });
  };

  static getLoginUrl = async (params) => {
    const baseUrl = await getAuthBaseUrl();
    const urlServer = joinUrlParts(baseUrl, getLoginUrl());

    return axios.get(urlServer, { params });
  };

  static getLoginOTP = async (params) => {
    const baseUrl = await getAuthBaseUrl();
    const urlServer = joinUrlParts(baseUrl, getLoginOtpUrl());

    return axios.get(urlServer);
  };

  static fetchToken = async (params) => {
    const baseUrl = await getAuthBaseUrl();
    const url = joinUrlParts(baseUrl, getVerifyUrl());

    return axios.get(url, { params });
  };

  static refreshToken = async (token, config = {}) => {
    const baseUrl = await getAuthBaseUrl(config);
    const url = joinUrlParts(baseUrl, getRefreshUrl());

    return axios.get(url, {
      params: { token },
    });
  };

  static revoke = async (continueAddress) => {
    const headers = {
      idToken: 'true',
    };
    const url = getRevoketUrl();
    return api
      .delete(url, { params: { continue: continueAddress }, headers: { ...headers } })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  };

  static fetchBusiness = async () => {
    const headers = {
      idToken: 'true',
    };
    const url = getBusinessUrl();
    const baseUrl = await getAuthBaseUrl();

    // Set dynamic base URL for axios
    api.axios.defaults.baseURL = baseUrl;
    return api.get(url, { headers: { ...headers } }).then((res) => {
      this.businessData = res?.data?.result;
      initialSentry(res?.data?.result);
      identifyTracker({ userId: res?.data?.result?.id })
      return res.data;
    });
  };



  static getLastLogin = async () => {
    const url = getUserLastLogin();
    return api.get(url).then((res) => res.data);
  };
}
